import React from 'react';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import DarkModeOutlinedIcon from '@mui/icons-material/DarkModeOutlined';
import LightModeOutlinedIcon from '@mui/icons-material/LightModeOutlined';
import { useTranslation } from '../app/LanguageContext';
import { useThemeMode } from '../app/ThemeModeContext';

const ThemeModeToggle = () => {
  const { translate } = useTranslation();
  const { mode, toggleMode } = useThemeMode();
  const isDark = mode === 'dark';

  return (
    <Tooltip
      title={isDark ? translate('common.theme_use_light') : translate('common.theme_use_dark')}
    >
      <span>
        <IconButton
          color="inherit"
          onClick={toggleMode}
          aria-label={
            isDark ? translate('common.theme_use_light') : translate('common.theme_use_dark')
          }
          size="medium"
        >
          {isDark ? <LightModeOutlinedIcon /> : <DarkModeOutlinedIcon />}
        </IconButton>
      </span>
    </Tooltip>
  );
};

export default ThemeModeToggle;
